import { j as o } from "./jsx-runtime-DmTjM30f.js";
import { i as t } from "./index-wI714H_N.js";
import { k as u } from "./index.esm-G8KyR0tM.js";
const s = ({ selectedLanguage: r, updateLocale: l }) => {
  const e = [
    {
      label: "English",
      value: "en"
    },
    {
      label: "हिन्दी",
      value: "hi",
      disabled: !0
    },
    {
      label: "தமிழ்",
      value: "tm",
      disabled: !0
    }
  ];
  return /* @__PURE__ */ o.jsx(u, {
    value: r,
    onChange: (a) => {
      l(a), t.activate(a == null ? void 0 : a.value);
    },
    options: e,
    variant: "menuPicker",
    placement: "top"
  });
};
export {
  s as LocaleSelector
};
